import React, {Fragment, useContext} from "react"
import '../../libs/react-spring-bottom-sheet/style.css'

import SheetPaiementDetail from "../sheets/SheetPaiementDetail";
import SheetAbonementDetail from "../sheets/SheetAbonementDetail";
import SheetPromesseDetail from "../sheets/SheetPromesseDetail";
import SheetSubmitDetail from "../sheets/SheetSubmitDetail";
import SheetContactFiche from "../sheets/SheetContactFiche";
import SheetStats from "../sheets/SheetStats";
import ModalContact from '../../modals/ModalContact';
import { isMobile } from 'react-device-detect';
import { isMobileApp } from '../../configs/AppConfig';

export const SheetContext = React.createContext(null)

export function useSheet(){
    return React.useContext(SheetContext)
}

export function withSheet(Component){
    return function WrappedComponent(props){
        const sheetManager=useSheet()
        return <Component {...props} sheetManager={sheetManager} />
    }
}

export default class SheetProvider extends React.Component
{

    initialState = {
        payload:null,
        forceClose:false,
        assocs:[]
    }

    state = this.initialState

    getPayload(){
        return this.state.payload || {};
    }

    setPayloadParams(_state={}){
        const newPayload={...this.state.payload};
        newPayload.params={...newPayload.params, ..._state};
        this.setState({ payload: newPayload });
    }

    forceReopen(){
        return new Promise((resolve) => {
            this.setState({forceClose:true},()=>{
                setTimeout(()=>{
                    this.setState({forceClose:false})
                    resolve()
                },100)
            })
        })

    }

    async openContact(contactData)
    {
        if(!isMobileApp){
            return this.modalContact.show(contactData.id)
        }

        let contactName=(contactData.nom+" "+contactData.prenom).replaceAll("undefined","").trim() || contactData.tel || contactData.email || ""
        return this.open("SheetContactFiche",contactName,{id:contactData.id})
    }

    async openStats(title,render){
        return this.open("SheetStats",title,{render:render})
    }

    async open(sheetID,title,params={}){
        let payload={sheetID:sheetID,title:title,params:params,onClose:null};

        if(this.state?.payload?.sheetID)
        {
            const prevPayload=this.state.payload;
            payload.closeText=prevPayload.title;
            payload.onClose=()=>{
                this.setState({payload:prevPayload});
            }
            await this.forceReopen();
        }

        this.setState({payload:payload});
    }

    async close(){
        if(this.state?.payload?.sheetID)
        {
            if(typeof this.state.payload?.onClose === "function")
            {
                await this.forceReopen();
                this.state.payload.onClose();
            }else
            {
                this.setState({payload:null});
            }
        }
    }

    async cancel(){
        this.setState(this.initialState)
    }

    render()
    {
        console.log("SheetProvider", this.state)

        return(
            <>
                <SheetContext.Provider value={this}>
                    {this.props.children}

                    <SheetContext.Consumer>
                        {(value)=>{
                            return(
                                <Fragment>
                                    <SheetPaiementDetail sheetContext={value} open={!this.state.forceClose && this.state?.payload?.sheetID==="SheetPaiementDetail"}/>
                                    <SheetAbonementDetail sheetContext={value} open={!this.state.forceClose && this.state?.payload?.sheetID==="SheetAbonementDetail"}/>
                                    <SheetPromesseDetail sheetContext={value} open={!this.state.forceClose && this.state?.payload?.sheetID==="SheetPromesseDetail"}/>
                                    <SheetSubmitDetail sheetContext={value} open={!this.state.forceClose && this.state?.payload?.sheetID==="SheetSubmitDetail"}/>
                                    <SheetContactFiche sheetContext={value} open={!this.state.forceClose && this.state?.payload?.sheetID==="SheetContactFiche"}/>
                                    <SheetStats sheetContext={value} open={!this.state.forceClose && this.state?.payload?.sheetID==="SheetStats"}/>
                                </Fragment>
                            )
                        }}
                    </SheetContext.Consumer>
                </SheetContext.Provider>

                <ModalContact getRef={(ref)=>this.modalContact=ref}/>
            </>
        )
    }
}
